export const Logo = ({ light = false }) =>
  light ? (
    <span className="inline-flex rounded-2xl bg-white px-3 py-2 shadow-lg shadow-black/20">
      <img
        src="/logo-full.png"
        alt="TopEstofos — Higienização e cuidado que transforma"
        className="h-14 w-auto"
      />
    </span>
  ) : (
    <span className="flex items-center gap-2.5">
      <img
        src="/logo-mark.png"
        alt="Logótipo TopEstofos"
        className="h-14 w-auto"
      />
      <span className="font-heading text-2xl font-extrabold tracking-tight text-navy">
        Top<span className="text-brand">Estofos</span>
      </span>
    </span>
  );
